import { render, staticRenderFns } from "./CardOrg1.vue?vue&type=template&id=1668e7fe&"
import script from "./CardOrg1.vue?vue&type=script&lang=js&"
export * from "./CardOrg1.vue?vue&type=script&lang=js&"
import style0 from "./CardOrg1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports